<template>
  <div>
    <div class="module-box bg-skin-secondary cursor-pointer" @click="showLesson = !showLesson">
      <div class="text-module flex text-skin-secondary">
        <div class="circle"
        :class="{
          'active': moduleSee
        }"></div>
        <div class="name-course mr-2">
          <span>{{ item.name }}</span> <br />
          <span class="number-class text-skin-tertiary">
            {{ clases }} clase</span
          >
        </div>
      </div>
      <div class="action-arrow">
        <img
          class="cursor-pointer"
          src="../assets/icon_expandir_modulo.svg"
          alt=""
          srcset=""
          v-if="!showLesson"
        />
        <img
          class="cursor-pointer transform-scale"
          src="../assets/icon_expandir_modulo.svg"
          alt=""
          srcset=""
          v-else
          @click="showLesson = !showLesson"
        />
      </div>
    </div>
    <collapse-transition>
      <div class="lesson" v-if="showLesson">
        <div v-for="lesson in lessons" :key="lesson.id">

          <div v-for="resource in lesson.resources" :key="resource.id">
            <LessonBox 
            @setLesson="setLesson" 
            :item="resource">
            </LessonBox>
          </div>

        </div>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
import LessonBox from "../components/LessonBox.vue";
import { CollapseTransition } from "@ivanv/vue-collapse-transition";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      showLesson: false,
      clases:0,
      moduleSee:false,
      changeToActive:false,
      lessons: []
    };
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    activeElem:{
      type: Number,
      default: 0,
    }
  },
  components: {
    LessonBox,
    CollapseTransition
  },
  computed: {
    ...mapGetters("userCourses", ["GET_ADDCOURSEUSER"]),
  },
  methods: {
    setLesson(value) {
      
      this.$router.push({ 
        name: "v2-course-detail", 
        params: { 
          id: this.item.mounted_course_id,
          resource: value.id,
        },
      });
      this.$store.commit("detailCourse/SET_LESSON", value);
    },
    activateModule(){
      let cont = 0
      this.clases = 0
      this.lessons.forEach(lesson => {
        lesson.resources.forEach(resourse => {
          if(resourse.type === 6 || resourse.type === 1){
            this.clases++
            if(this.GET_ADDCOURSEUSER){
              if(resourse.id == this.$route.params.resource){
                this.$store.commit("userCourses/SET_ADDCOURSEUSER", false)
                resourse.resource_person.push('new')
              }
            }
            if (resourse.resource_person.length> 0)
              cont++
          }
        })
      })
      if(cont == this.clases)
        this.moduleSee = true
    }
  },
  mounted(){
    this.lessons = this.item.lessons
    this.activateModule()
  },
  watch:{
    GET_ADDCOURSEUSER(){
      if(this.GET_ADDCOURSEUSER)
        this.activateModule()
    }
  }
};
</script>

<style scoped>
.transform-scale {
  transform: scaleY(-1);
}

.module-box {
  box-shadow: 2px 2px 5px #00000029;
  border-radius: 7px;
  opacity: 1;
  padding: 15px 37px 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
}

.text-module {
  text-align: left;
  font: normal normal bold 16px/19px Roboto;
  letter-spacing: 0px;
  opacity: 1;
  justify-content: flex-start;
  align-items: center;
}

.circle {
  width: 12px;
  height: 12px;
  border: 2px solid #e55974;
  opacity: 1;
  border-radius: 50%;
  margin-right: 10px;
  position: absolute;
  top: 20px;
  left: 10px;
}

.circle.active {
  background: #e55974;
}

.number-class {
  font: normal normal normal 12px/14px Roboto;
  letter-spacing: 0px;
  opacity: 1;
}

.action-arrow {
  position: absolute;
  right: 20px;
}
</style>
